module.exports = __webpack_public_path__ + "static/media/lingmingshan2.362325ab.webp";